const TZ = 'Europe/Copenhagen'

// Intl formatters are slow to create and the page formats hundreds of values, so each is made once.
const cache = new Map()
function cached(key, create) {
  if (!cache.has(key)) cache.set(key, create())
  return cache.get(key)
}
const fmt = (options) =>
  cached(`date:${JSON.stringify(options)}`, () => new Intl.DateTimeFormat('da-DK', { timeZone: TZ, ...options }))
const relative = (style) =>
  cached(`relative:${style}`, () => new Intl.RelativeTimeFormat('da-DK', { numeric: 'auto', style }))
const money = () =>
  cached('money', () => new Intl.NumberFormat('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))

// 6500 -> "65,00"
export const kr = (ore) => money().format(ore / 100)

// 6500 -> "65 kr", 6550 -> "65,50 kr"
export const krShort = (ore) => (ore % 100 === 0 ? `${ore / 100} kr` : `${kr(ore)} kr`)

export const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1)

export const weekday = (iso) => fmt({ weekday: 'long' }).format(new Date(iso))
export const dayMonth = (iso) => fmt({ day: 'numeric', month: 'long' }).format(new Date(iso))
export const shortDate = (iso) => fmt({ day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(iso))
export const clock = (iso) => fmt({ hour: '2-digit', minute: '2-digit' }).format(new Date(iso))

// "om 2 dage", "om 5 timer"
export function fromNow(iso, now = Date.now()) {
  const rtf = relative('long')
  const minutes = Math.round((new Date(iso) - now) / 60000)
  if (Math.abs(minutes) < 60) return rtf.format(minutes, 'minute')
  const hours = Math.round(minutes / 60)
  if (Math.abs(hours) < 36) return rtf.format(hours, 'hour')
  return rtf.format(Math.round(hours / 24), 'day')
}

// "Lørdag 26/9"
export function shortDay(iso) {
  const parts = Object.fromEntries(fmt({ day: 'numeric', month: 'numeric' }).formatToParts(new Date(iso)).map((p) => [p.type, p.value]))
  return `${capitalize(weekday(iso))} ${parts.day}/${parts.month}`
}

// "9", "9.30" – for compact ranges like "kl. 9–12"
export function shortTime(iso) {
  const [hours, minutes] = clock(iso).split('.')
  return minutes === '00' ? String(Number(hours)) : `${Number(hours)}.${minutes}`
}

// "lige nu", "for 5 min. siden", "i går", "for 3 dage siden"
export function ago(iso, now = Date.now()) {
  const seconds = Math.round((now - new Date(iso)) / 1000)
  if (seconds < 60) return 'lige nu'
  const rtf = relative('short')
  // Intl gives "5 min. siden"; Danish reads more naturally as "for 5 min. siden".
  const phrase = (text) => (text.endsWith('siden') && !text.startsWith('for') ? `for ${text}` : text)
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return phrase(rtf.format(-minutes, 'minute'))
  const hours = Math.round(minutes / 60)
  if (hours < 24) return phrase(rtf.format(-hours, 'hour'))
  const days = Math.round(hours / 24)
  if (days < 7) return phrase(rtf.format(-days, 'day'))
  return dayMonth(iso)
}
